import styled from "styled-components";

export const DropBoxWrapper = styled.div`
  position: relative;
`;

export const DropBoxValue = styled.div`
  border: 1px solid var(--Black-200, #b7b7b7);
  width: 57;
  height: 30px;
  border-radius: 15px;
  padding-top: 9px;
  padding-right: 8px;
  padding-bottom: 9px;
  padding-left: 12px;
  font-weight: 600;
  font-size: 12px;
  color: var(--Black-500, #202020);
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
`;

export const DropBoxOptionWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px;
  overflow-y: auto;
  right: 0;
  top: 36px;
  z-index: 105;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
`;

export const DropBoxItem = styled.div<{ isSelected: boolean }>`
  width: 100%;
  cursor: pointer;
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  border: 1px solid var(--Black-100, #f0f0f0);
  color: ${(p) => (p.isSelected ? "#fff" : "var(--Black-500, #202020)")};
  background: ${(p) => (p.isSelected ? "var(--Purple-300, #6436e7)" : "#fff")};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
`;
